import { PencilBaseIcon } from '@tableau/icons/PencilBaseIcon';
import { ButtonType, ButtonWidget } from '@tableau/widgets';
import React from 'react';

import { openReactActionDialog } from '~commonInfra/dialogs/ReactActionDialog';
import { TabDialogWidth } from '~commonInfra/dialogs/style/TabDialogWidth';
import { ToasterService, ToastType } from '~commonInfra/services/ToasterService';
import { Messages } from '~src/codegen/Localize';
import { EditBridgePoolDialogBody, EditBridgePoolDialogProps, EditBridgePoolDialogState } from '~src/settings/bridge-settings/sections/bridgeMultiPool/EditBridgePoolDialog';
import { IUpdateEdgePoolParams, IUpdateEdgePoolResult } from '~src/settings/bridge-settings/serverApi/requests/UpdateEdgePoolRequest';
import { EdgePool } from '~src/settings/bridge-settings/serverApi/resources/EdgePool';

import { UserDefinedPoolModel } from '../types/PoolModel';
import { getErrorMessage } from '../utils/EdgePoolErrorUtilities';

export type EditPoolButtonProps = Readonly<{
  pool: UserDefinedPoolModel;
  existingPoolNames: ReadonlyArray<string>;
  siteId: string;
  refreshEdgePools: () => void;
}>;

export function EditPoolButton(props: EditPoolButtonProps) {
  return (
    <span className={'tb-data-grid-icon tb-padded-left-large'} data-tb-test-id={'pool-edit-cell'}>
      <ButtonWidget
        title={Messages.edit()}
        buttonType={ButtonType.Icon}
        testId={'edit-pool-button'}
        onClick={() => openEditPoolDialog(props.pool, props.existingPoolNames, props.siteId, props.refreshEdgePools)}
      >
        <PencilBaseIcon size={14} aria-hidden={true} />
      </ButtonWidget>
    </span>
  );
}

function openEditPoolDialog(pool: UserDefinedPoolModel, existingPoolNames: ReadonlyArray<string>, siteId: string, refreshEdgePools: () => void) {
  const action = (_: EditBridgePoolDialogProps, state: EditBridgePoolDialogState) => {
    const updateProps: IUpdateEdgePoolParams = {
      poolId: pool.id,
      displayName: state.poolName,
      domainChange: null,
      agentChange: null,
      siteId: siteId,
      bridgeSettingsVersion: '0'
    };

    EdgePool.updatePool(updateProps)
      .then((result: IUpdateEdgePoolResult) => {
        refreshEdgePools();
        if(result.success) {
          ToasterService.instance.pop({ type: ToastType.Success, text: Messages.bridgeSiteSettingsEditPoolSuccess() });
        }
        if(result.error) {
          ToasterService.instance.pop({
            type: ToastType.Error,
            text: getErrorMessage(result.error.errorCode, {poolName: pool.displayName, domainName: null, agentName: null})
        });
        }
      });
    return Promise.resolve();
  };

  const dialogInstance = openReactActionDialog({
    title: Messages.bridgeSiteSettingsEditPool(),
    bodyComponent: EditBridgePoolDialogBody,
    initialBodyProps: { existingPoolNames },
    initialDialogState: { poolName: pool.displayName, hasError: false },
    actionName: Messages.save(),
    action: action,
    actionDisabled: (_, state: EditBridgePoolDialogState) => state.poolName.length === 0 || state.hasError,
    dismissDialogOnActionFailed: true,
    dialogWidth: TabDialogWidth.width375px,
  });

  return Promise.resolve(dialogInstance.result);
}
